import { BusinessesPanel } from "../components/BusinessesPanel";

export function BusinessesPage() {
  return <BusinessesPanel />;
}
